import { IdValue } from '../../../shared/models/id-value.model';

export const maritalStatusTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Married', 'Married'),
  new IdValue(3, 'Unmarried', 'Unmarried'),
  new IdValue(2, 'Separated', 'Separated'),
];

export const citizenResidencyTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'UsCitizen', 'US Citizen'),
  new IdValue(2, 'PermanentResidentAlien', 'Permanent Resident Alien'),
  new IdValue(3, 'NonPermanentResidentAlien', 'Non-Permanent Resident Alien'),
  new IdValue(4, 'NonResidentAlien', 'Non-Resident Alien'),
  new IdValue(5, 'Unknown', 'Unknown'),
];
